import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  ordersList: [],
  singleOrder: null,
  status: false,
  error: null,
  totalPage: null,
  currentPage: null,
  totalCount: null,
  orderState: {
    data: null,
    loading: null,
    error: null,
  },
  singleTicketState: {
    data: null,
    loading: null,
    error: null,
    submitting: null,
  },
};

export const createOrder = createAsyncThunk(
  "vendorbydomain/order",
  async (orderPayload, { dispatch, rejectWithValue }) => {
    try {
      if (!orderPayload) {
        rejectWithValue("Please Provide Data!");
      }
      const reqData = {
        vendorId: orderPayload.vendorId || "66e80f7782499a7a869ff972",
        otp: orderPayload.otp,
      };

      dispatch(createOrderStart());
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/e-commerce/order/create`,
        // reqData
        orderPayload
      );
      if (response?.status) {
        dispatch(createOrderSuccess(response));
        return response;
      } else {
        const errorMsg = response?.data?.message ?? "Something went wrong!!";
        dispatch(createOrderFailure(errorMsg));
        return rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message ?? "Something went wrong!!";
      dispatch(createOrderFailure(errorMsg));
      return rejectWithValue(errorMsg);
    }
  }
);
export const updateOrder = createAsyncThunk(
  "vendorbydomain/order",
  async ({ orderId, status, transactionId }, { dispatch, rejectWithValue }) => {
    try {
      if (!orderId) {
        rejectWithValue("No order!");
      }
      const reqData = {
        transactionId,
        orderId,
      };
      dispatch(updateOrderStart());
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/e-commerce/order/update`,
        { transactionId, status, orderId }
      );
      // const response = await axios.put(
      //   `${process.env.REACT_APP_API_URL}/api/e-commerce/order/${orderId}/payment-confirm`,
      //   reqData
      // );
      if (response?.status) {
        dispatch(updateOrderSuccess(response));
      } else {
        const errorMsg = response?.data?.message ?? "Something went wrong!!";
        dispatch(updateOrderFailure(errorMsg));
        return rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message ?? "Something went wrong!!";
      dispatch(updateOrderFailure(errorMsg));
      return rejectWithValue(errorMsg);
    }
  }
);

export const getOrders = createAsyncThunk(
  "product/Product",
  async ({ page, pageSize, userEmail }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getOrdersStart());
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/e-commerce/order_history?page=${
          page || 1
        }&size=${pageSize || 10}&userEmail=${userEmail}`
      );

      dispatch(getOrdersSuccess(response.data));
      return response?.data?.data;
    } catch (error) {
      dispatch(getOrdersFailure(error.response.data.message));
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getOrderById = createAsyncThunk(
  "order/getOrderById",
  async (orderId, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getOrderByIdStart());
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/e-commerce/order/${orderId}`
      );
      dispatch(getOrderByIdSuccess(response?.data?.data));
      return response?.data;
    } catch (error) {
      dispatch(getOrderByIdFailure(error?.response?.data?.message));
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const verifyPayment = createAsyncThunk(
  "verify-payment",
  async (payloadData, { dispatch, rejectWithValue }) => {
    try {
      if (!payloadData) {
        rejectWithValue("Please Response and orderId Data!");
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/e-commerce/order/create-razorpay-order/verify-payment`,
        payloadData
      );
      if (response?.status) {
        return response;
      } else {
        const errorMsg = response?.data?.message ?? "Something went wrong!!";
        return rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message ?? "Something went wrong!!";
      return rejectWithValue(errorMsg);
    }
  }
);
//for orders query message
export const addTicket = createAsyncThunk(
  "branch/addTicket",
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      const {
        ordersListData: {
          singleTicketState: { data },
        },
      } = getState();

      //converting ptoduct it into array of objects
      const productItem = [{ id: data?.products }];

      if (!data) {
        return rejectWithValue("Please provide data!");
      }
      if (!data.orderNo) {
        return rejectWithValue("Please provide OrderNo!");
      }
      if (!data.complaintType) {
        return rejectWithValue("Please provide the type of Complaint!");
      }
      if (data.complaintType == "Others" && !data.title) {
        return rejectWithValue("Please brief your issue");
      }

      dispatch(addTicketStart());
      let formData = new FormData();
      const reqData = {
        complaintDate: data.complaintDate,
        complaintType: data.complaintType,
        vendor: data.vendorId,
        vendorBranch: data.vendorBranch,
        status: data.status,
        branch: data.branch,
        title: data.title,
        ticketNo: data.ticketNo || "",
        description: data.description,
        orderNo: data.orderNo,
        products: productItem,
        customerEmail: data.customerEmail,
        customerMobile: data.customerMobile,
        customerName: data.customerName,
      };
      formData.append("data", JSON.stringify(reqData));
      let response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/ticket`,
        formData
      );

      if (response?.status) {
        dispatch(addTicketSuccess());

        dispatch(setTicketData(null));

        return response;
      } else {
        const errorMsg = response?.data?.message ?? "Something went wrong!!";
        dispatch(addTicketFailure(errorMsg));
        return rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message ?? "Something went wrong!!";
      dispatch(addTicketFailure(errorMsg));
      return rejectWithValue(errorMsg);
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    createOrderStart(state) {
      state.orderState.loading = true;
      state.orderState.error = null;
    },
    createOrderSuccess(state, action) {
      state.orderState.loading = false;
      state.orderState.error = null;
      state.orderState.data = action.payload;
    },
    createOrderFailure(state, action) {
      state.orderState.loading = false;
      state.orderState.error = action.payload;
    },
    updateOrderStart(state) {
      state.orderState.loading = true;
      state.orderState.error = null;
    },
    updateOrderSuccess(state, action) {
      state.orderState.loading = false;
      state.orderState.error = null;
      state.orderState.data = action.payload;
    },
    updateOrderFailure(state, action) {
      state.orderState.loading = false;
      state.orderState.error = action.payload;
    },
    getOrdersStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    getOrdersSuccess(state, action) {
      state.isLoading = false;
      state.ordersList = action.payload.data;
      state.totalPage = action.payload.data?.totalPages;
      state.totalCount = action.payload.data?.totalCount;
      state.currentPage = action.payload.data?.currentPage;
    },
    getOrdersFailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
      state.singlealbum = null;
    },
    getOrderByIdStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    getOrderByIdSuccess(state, action) {
      state.isLoading = false;
      state.singleOrder = action.payload;
    },
    getOrderByIdFailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    addTicketStart(state) {
      state.singleTicketState.loading = true;
      state.singleTicketState.error = null;
    },
    setTicketData(state, action) {
      state.singleTicketState.data = action.payload;
    },

    addTicketSuccess(state) {
      state.singleTicketState.loading = false;
      state.singleTicketState.submitting = false;
      state.singleTicketState.error = null;
    },
    addTicketFailure(state, action) {
      state.singleTicketState.loading = false;
      state.singleTicketState.submitting = false;
      state.singleTicketState.error = action.payload;
    },
  },
});

export const {
  createOrderStart,
  createOrderSuccess,
  createOrderFailure,
  updateOrderStart,
  updateOrderSuccess,
  updateOrderFailure,
  getOrdersStart,
  getOrdersSuccess,
  getOrdersFailure,
  getOrderByIdStart,
  getOrderByIdSuccess,
  getOrderByIdFailure,
  addTicketStart,
  setTicketData,
  addTicketSuccess,
  addTicketFailure,
} = orderSlice.actions;

export default orderSlice.reducer;
